import { axiosPut } from 'shared/api/axios'
import { apiUrls } from 'consts'

const reorderAll = async (endpoint: string, data: Array<number>) => {
  const requestParams = { order: data }

  const catchFn = (error) => {
    return false
  }

  const response = await axiosPut(endpoint + '/' + apiUrls.actionSort, requestParams, catchFn)
  return response
}

export default reorderAll
